








































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const indexManagementModule = namespace('index')
@Component({
  components: {}
})
export default class Index extends Vue {
  sysName: string = ''
  showPopup: boolean = false
  columns: any = []
  selectVal: any = {}
  parentShow: boolean = false
  radio: string = ''
  radioList: any = []
  mounted() {
    this.getUserMsg()
    this.getAccountRelationEntity()
    this.systemId()
  }
  handleShowPopup() {
    console.log(this.columns)
    if (this.columns.length < 1) {
      return
    }
    this.showPopup = true
  }
  onConfirm(value: any, index: any) {
    console.log(value)
    this.selectVal = value
    this.showPopup = false
    this.sysName = value.businessEntityNameCn
    this.setLocalStorage(value.businessEntityId, value.businessEntityTypeId)
  }
  handleBtn() {
    if (this.columns.length < 1) {
      return
    }
    this.setLocalStorage(
      this.selectVal.businessEntityId,
      this.selectVal.businessEntityTypeId
    )
    console.log(this.selectVal)
    console.log(this.selectVal.businessEntityTypeId)
    this.getParentList(this.selectVal.businessEntityId)
  }
  parentBtnCancel() {
    this.parentShow = false
  }

  parentBtnSure() {
    console.log(this.radioList)
    if (this.radioList) {
      for (let i = 0; i < this.radioList.length; i++) {
        if (this.radio == this.radioList[i].id) {
          this.setParentLocalStorage(
            this.radioList[i].parentBusinessEntityId,
            this.radioList[i].parentBusinessEntityTypeId,
            this.radioList[i].businessEntityNameCn
          )
        }
      }
    }
    console.log(localStorage)
    ;(this.$router as any).options.routes = []
    // let pathUrl =
    //   this.selectVal.businessEntityTypeId == 1 ? '/manageHome' : '/home'
    let pathUrl = '/home'
    console.log(pathUrl)
    this.$router.push(pathUrl)
  }
  getUserMsg() {
    let queryParams: Array<string> =
      (window.location as any).href.match(/[^#?&]+=[^#?&]+/gi) || []
    let params: any = {}
    while (queryParams.length) {
      let query = (queryParams as any).shift().split('=')
      params[query[0]] = query[1]
    }
    let token: string = params.token || localStorage.getItem('ma6_token')
    let accountId: string =
      params.accountId || localStorage.getItem('ma6_accountId')
    let params_info = {
      token,
      accountId
    }
    localStorage.setItem('ma6_token', params_info.token)

    //设置全局header, 后面的所有请求都会带上这些header信息
    this.$request.setHeader('token', params_info.token)

    //设置全局变量, 在项目任何需要的地方都可以很方便的使用这些变量, 并且这些变量是双向绑定的
    this.$global.set('token', params_info.token)
    this.$global.set('uId', params_info.accountId)
  }
  goBack() {
    const wx: any = (window as any).wx
    ;(wx as any).miniProgram.reLaunch({
      url: '/pages/login/login?status=1'
    })
  }
  async getAccountRelationEntity() {
    const { success, error }: any = await this.$store.dispatch(
      'index/getAccountRelationEntity',
      {
        accountId: this.$global.uId,
        pageSize: 1000
      }
    )
    if (success) {
      console.log('success', success)
      if (success.data && success.data.list) {
        if (success.data.list.length < 1) {
          this.sysName = '该账号未绑定主体，请联系管理员'
          return
        }
        this.columns = success.data.list
        this.sysName = success.data.list[0].businessEntityNameCn
        this.selectVal = success.data.list[0]
      }
    }
    if (error) {
      console.log('error', error)
    }
  }
  /**
   * 获取商户通系统Id
   */
  async systemId() {
    const { success, error }: any = await this.$request('GET_ZUKER_SYSTEMID', {
      code: 'maShopSystemId',
      businessEntityId: 1
    })
    if (success) {
      let items = success.data
      for (let i = 0; i < items.length; i++) {
        if (items[i].workflowStatusId == 5) {
          localStorage.setItem('ma6_systemId', items[i].itemKey)
        }
      }
    }
  }
  /**
   * 获取父级主体列表
   */
  async getParentList(businessEntityId: any) {
    const { success, error }: any = await this.$request(
      'PARENTACCOUNT_RELATION_LIST',
      {
        businessEntityId: businessEntityId
      }
    )
    if (success) {
      let radioItems = success.data
      this.radioList = radioItems
      console.log(radioItems)
      if (radioItems) {
        if (radioItems.length > 1) {
          this.parentShow = true
          this.radio = radioItems[0].id
        } else {
          this.parentShow = false
          this.radio = radioItems[0].id
          radioItems =
            radioItems && radioItems.length == 1 ? radioItems[0] : null
          this.setParentLocalStorage(
            radioItems.parentBusinessEntityId,
            radioItems.parentBusinessEntityTypeId,
            encodeURIComponent(radioItems.businessEntityNameCn)
          )
          ;(this.$router as any).options.routes = []
          // let pathUrl =
          //   this.selectVal.businessEntityTypeId == 1 ? "/manageHome" : "/home";
          let pathUrl = '/home'
          console.log(pathUrl)
          this.$router.push(pathUrl)
        }
      } else {
        ;(this.$router as any).options.routes = []
        // let pathUrl =
        //   this.selectVal.businessEntityTypeId == 1 ? '/manageHome' : '/home'
        let pathUrl = '/home'
        console.log(pathUrl)
        this.$router.push(pathUrl)
      }
    }
  }
  setLocalStorage(tenantId: any, tenantType: any) {
    localStorage.setItem('ma6_businessEntityId', tenantId)
    localStorage.setItem('ma6_businessEntityTypeId', tenantType)
    //设置全局header, 后面的所有请求都会带上这些header信息
    this.$request.setHeader('tenantId', tenantId)
    this.$request.setHeader('tenantType', tenantType)

    //设置全局变量, 在项目任何需要的地方都可以很方便的使用这些变量, 并且这些变量是双向绑定的.
    this.$global.set('tenantId', tenantId)
    this.$global.set('tenantType', tenantType)
  }
  setParentLocalStorage(parentId: any, parentType: any, parentName: any) {
    localStorage.setItem('ma6_parentBusinessEntityId', parentId)
    localStorage.setItem('ma6_parentBusinessEntityTypeId', parentType)
    this.$global.set('parentName', encodeURIComponent(parentName))
  }
}
